/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/tag': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20.99 13.81l-7.17 7.17a1.998 1.998 0 01-2.83 0L2.4 12.4v-10h10l8.59 8.59a2 2 0 010 2.82v0z" _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M7.4 7.4h.01" _stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
